import React from 'react';

const Copyright = () => {
    return (
        <div className="copyright">
            <p>© Copyright 2026 Junwon Lee.</p>  
            {/* <p> <a href="https://ct.kaist.ac.kr/">Graduate School of Culture Technology</a></p> */}
        </div>
    );
};

export default Copyright;
